<section class="db-outline-handler-container">
  <section class="db-outline-generation-container" [formGroup]="generationForm">
    <div>
      <div class="db-outline-handler-field-label">Company type</div>
      <input class="ds-textarea ds-textarea-black" formControlName="business_type">
    </div>
    <div>
      <div class="db-outline-handler-field-label">Description</div>
      <textarea class="ds-textarea ds-textarea-black" formControlName="description" rows="3"></textarea>
    </div>
      <ng-container
        *ngTemplateOutlet="customFieldTemplate; context: { $implicit: generationForm, controls:generationFormArray.controls, removeField: removeGenerationField, addField: addGenerationField }">
      </ng-container>
    <div class="db-outline-handler-action-container">
      <input class="ds-checkbox" type="checkbox" id="testEnv"
             (change)="testMode = !testMode">
      <label for="testEnv" class="ds-checkbox-label">
        <b>Test env</b>
      </label>
      <button class="ds-btn-black"
              [class.ds-btn-disabled]="generationForm.invalid"
              (click)="generateOutline()">
        Generate
      </button>
    </div>
  </section>
  <section class="db-outline-drag-container"
           *ngIf="!!sections.length"
           [formGroup]="pageOutlineForm">
    <div class="custom-field-btn-container">
      <span (click)="addSection()">Add section</span>
    </div>
    <div formArrayName="sections"
         class="sections-container"
         dbScrollOnDrag
         [drake]="dragulaService?.find('sections')?.drake"
         [dragula]='"sections"'
         [dragulaModel]="sections">
      <div class="db-outline-drag-section"
           *ngFor="let section of sectionsFormArray.controls; let i = index">
        <ng-container [formGroupName]="i.toString()">
          <div>
            <div class="db-outline-handler-field-label">Section title</div>
            <input class="ds-textarea ds-textarea-black" formControlName="section_title">
            <i class="db-icon db-icon-error remove-section-icon" (click)="removeSection(i)"></i>
          </div>
          <div>
            <div class="db-outline-handler-field-label">Section type</div>
            <input class="ds-textarea ds-textarea-black" formControlName="section_type">
          </div>
          <div>
            <div class="db-outline-handler-field-label">Section description</div>
            <textarea class="ds-textarea ds-textarea-black" formControlName="section_description" rows="3"></textarea>
          </div>
          <ng-container
            *ngTemplateOutlet="customFieldTemplate; context: { $implicit: sectionsFormArray.at(i), controls: sectionsFormArray.at(i).get('custom_fields')['controls'], removeField: removeSectionField, addField: addSectionField, index:i }">
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="db-outline-handler-action-container">
      <input class="ds-checkbox" type="checkbox" id="generate_images"
             (change)="generateImages = !generateImages">
      <label for="generate_images" class="ds-checkbox-label">
        <b>Generate images</b>
      </label>
      <a [href]="fileUrl" download="file.zip" *ngIf="fileUrl">Download zip</a>
      <button class="ds-btn-black"
              [class.ds-btn-disabled]="pageOutlineForm.invalid"
              (click)="saveOutline()">
        Save
      </button>
    </div>
  </section>
</section>

<ng-template #customFieldTemplate let-group let-index="index" let-controls='controls' let-removeField="removeField" let-addField="addField">
  <ng-container [formGroup]="group">
    <div class="custom-field-btn-container">
      <span (click)="addField.call(this, index)">Add custom field</span>
    </div>
    <div class="custom-field-list-container" formArrayName="custom_fields">
      <div *ngFor="let section of controls; let i = index">
        <div class="custom-field-container" [formGroupName]="i.toString()">
          <div class="custom-field-key-container">
            <div class="db-outline-handler-field-label">Field key</div>
            <input class="ds-textarea ds-textarea-black" formControlName="field_key"/>
          </div>
          <div class="custom-field-value-container">
            <div class="db-outline-handler-field-label">Field value</div>
            <textarea class="ds-textarea ds-textarea-black" formControlName="field_value"></textarea>
          </div>
          <i class="db-icon db-icon-error" (click)="removeField.call(this, i, index)"></i>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<db-loading-screen *ngIf="loading"></db-loading-screen>
